import { IBaseContact } from './IBaseContact';
import { IPresentationContactData } from './IPresentationContactData';
import { IAddressData } from '../../ui-toolkit/orders/interfaces/IAddressResponse';

export interface IThirdPartyContactRequest extends IBaseContact<string> {
  emailAddress: string;
  companyName: string;
  phoneNumber: string;
  mailingAddress: IAddressData;
}

export type IThirdPartyContactData = IThirdPartyContactRequest;

export type IPresentationThirdPartyContact = IPresentationContactData<IThirdPartyContactData, string>;

export const convertFromIThirdPartyContactRequestToIThirdPartyContactData = (
  data: IThirdPartyContactRequest
): IThirdPartyContactData => data;
export const convertFromIThirdPartyContactDataToIThirdPartyContactRequest = (
  data: IThirdPartyContactData
): IThirdPartyContactRequest => data;

export const convertFromIThirdPartyContactRequestArrayToIThirdPartyContactDataArray = (
  data: IThirdPartyContactRequest[]
): IThirdPartyContactData[] => data;
